import {
  ODataHeader, ODataString, ODataDecimal, ODataDateTime,
} from "pbas-vue-components";

  const OptOutReimbursementHeaders = [
    new ODataHeader({
      title: "First Name",
      type: new ODataString("OptOutRequest/FirstName"),
      sortable: true,
      visible: true,
      searchable: true,
      align: "left",
      width: "15%"
    }),    
    new ODataHeader({
      title: "Last Name",
      type: new ODataString("OptOutRequest/LastName"),
      sortable: true,
      visible: true,
      searchable: true,
      align: "left",
      width: "15%"
    }),
    new ODataHeader({
      title: "Certificate",
      type: new ODataString("OptOutRequest/Certificate"),
      sortable: true,
      visible: true,
      searchable: true,
      align: "left",
      width: "15%"
    }),
    new ODataHeader({
      title: "Address",
      type: new ODataString("OptOutRequest/Address"),
      sortable: true,
      visible: true,
      searchable: true,
      align: "left",
      width: "15%"
    }),
    new ODataHeader({
      title: "Deposit",
      type: new ODataString("ReimbursementType"),
      sortable: true,
      visible: true,
      searchable: true,
      align: "left",
    }),
    new ODataHeader({
      title: "Institution Number",
      type: new ODataString("OptOutRequest/InstitutionNumber"),
      sortable: true,
      visible: true,
      searchable: true,
      align: "left",
    }),
    new ODataHeader({
      title: "Account Number",
      type: new ODataString("OptOutRequest/AccountNumber"),
      sortable: true,
      visible: true,
      searchable: true,
      align: "left",
    }),
    new ODataHeader({
      title: "Transit Number",
      type: new ODataString("OptOutRequest/TransitNumber"),
      sortable: true,
      visible: true,
      searchable: true,
      align: "left",
    }),
    new ODataHeader({
      title: "Date",
      type: new ODataDateTime("Date"),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
      width: "15%"
    }),
    new ODataHeader({
      title: "Coverage(s)",
      type: new ODataString("OptOutRequest/OptOuts/CoverageGroup/Name"),
      sortable: true,
      visible: true,
      width: "15%"
    }),
    new ODataHeader({
      title: "Total Amount",
      type: new ODataDecimal("TotalAmount"),
      align: "right",
      sortable: true,
      visible: true,
      searchable: true,
      width: "15%"
    })
  ];
  export default OptOutReimbursementHeaders;